import {Col, Divider, Form, Input, Row} from "antd";
import {useEffect} from "react";
import dayjs from "dayjs";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import CommonFunction from "../../../util/CommonFunction";
import {NOT_AVAILABLE, YYYY_MM_DD_HH_MM} from "../../../util/Constants";


interface AuditInformationProps {
    adminWorkBasketDto: WorkbasketTableDto
}

const AuditInformation = (props: AuditInformationProps) => {
    const [form] = Form.useForm();

    useEffect(() => {
        setFormValue(props.adminWorkBasketDto);
    }, []);

    const setFormValue = (adminWorkBasketDto: WorkbasketTableDto) => {
        form.setFieldsValue(
            {
                customerVerificationUpdateDateTime: dateValidate(adminWorkBasketDto?.customerVerificationUpdateDateTime),
                customerVerificationAssignee: CommonFunction.validateText(adminWorkBasketDto.customerVerificationAssignee),
                videoVerificationUpdateDateTime: dateValidate(adminWorkBasketDto?.videoVerificationUpdateDateTime),
                videoVerificationAssignedDateTime: dateValidate(adminWorkBasketDto?.videoVerificationAssignedDateTime),
                videoVerificationAssignee: CommonFunction.validateText(adminWorkBasketDto.videoVerificationAssignee),
                detailVerificationUpdateDateTime: dateValidate(adminWorkBasketDto?.detailVerificationUpdateDateTime),
                detailVerificationAssignedDateTime: dateValidate(adminWorkBasketDto?.detailVerificationAssignedDateTime),
                detailVerificationAssignee: CommonFunction.validateText(adminWorkBasketDto.detailVerificationAssignee),
            }
        )

    }
    const dateValidate = (date: string | undefined) => {
      return undefined != date ? dayjs(date).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE
    }

    return (
        <div>
            <Form
                className='form-input'
                layout={"vertical"}
                form={form}
                disabled={true}

            >

                <Row gutter={[32, 0]}>
                    <Col span={24}>
                        <Divider orientationMargin="0" className='upload-document-divider'
                             orientation="left">Document Verification</Divider>
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Form.Item
                            label="Assignee"
                            name={"detailVerificationAssignee"}>
                            <Input placeholder={"Document Verification Assignee"}/>
                        </Form.Item>
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Form.Item
                            label="Assigned Datetime"
                            name={"detailVerificationAssignedDateTime"}>
                            <Input placeholder={"Document Verification Assigned Datetime"}/>
                        </Form.Item>
                    </Col>

                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Form.Item
                            label="Updated Datetime"
                            name={"detailVerificationUpdateDateTime"}>
                            <Input placeholder={"Document Verification Updated Datetime"}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Divider orientationMargin="0" className='upload-document-divider'
                             orientation="left">Video Verification</Divider>
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Form.Item
                            label="Assignee"
                            name={"videoVerificationAssignee"}>
                            <Input placeholder={"Video Verification Assignee"}/>
                        </Form.Item>
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Form.Item
                            label="Assigned Datetime"
                            name={"videoVerificationAssignedDateTime"}>
                            <Input placeholder={"Video Verification Assigned Datetime"}/>
                        </Form.Item>
                    </Col>

                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Form.Item
                            label="Updated Datetime"
                            name={"videoVerificationUpdateDateTime"}>
                            <Input placeholder={"Video Verification Updated Datetime"}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Divider orientationMargin="0" className='upload-document-divider'
                                 orientation="left">Customer Verification</Divider>
                    </Col>

                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Form.Item
                            label="Assignee"
                            name={"customerVerificationAssignee"}>
                            <Input placeholder={"Customer Verification Assignee"}/>
                        </Form.Item>
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Form.Item
                            label="Updated Datetime"
                            name={"customerVerificationUpdateDateTime"}>
                            <Input placeholder={"Customer Verification Updated Datetime"}/>
                        </Form.Item>
                    </Col>


                </Row>

            </Form>

        </div>
    )
}
export default AuditInformation